import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [gallery, setGallery] = useState([]);

  const load = () => {
    api.get("/content").then((r) => setContent(r.data || {})).catch(() => setContent({}));
    api.get("/gallery").then((r) => setGallery(r.data || [])).catch(() => {});
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <ContentContext.Provider value={{ content, gallery, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () =>
  useContext(ContentContext) || { content: {}, gallery: [], reload: () => {} };
